<template>
	<div class="Monitoring-binding">
		<div class="customer-info">
			<span class="info-item">客户名称：{{ detailData.customerName }}</span>
			<span class="info-item">服务单号：{{ detailData.serviceCode }}</span>
			<span class="info-item">网站主域名：{{ detailData.domain || '-' }}</span>
			<span class="info-item"
				>外贸行业：
				<span v-if="gtmDetailsData.foreignSecondIndustryName"
					>{{ gtmDetailsData.industryName }}-{{ gtmDetailsData.foreignSecondIndustryName }}</span
				>
				<span v-else-if="gtmDetailsData.industryName">{{ gtmDetailsData.industryName }}</span>
				<span v-else>未配置</span>
				<el-button type="text" @click="opendialog" class="industryNameEdit">编辑</el-button>
			</span>
		</div>
		<div class="data-binding">
			<binding-module :dataList="GaDataList"></binding-module>
		</div>
		<data-list
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="columns"
			:loading="loading"
			:page="page"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
		></data-list>

		<!-- GSC -->
		<gscAuthorization :zjzProjectId="detailData.zjzProjectId" />

		<!-- 外贸行业编辑弹框 -->
		<el-dialog title="外贸行业配置" :visible.sync="dialogVisible" width="30%">
			<form-combination :form-data="groups"></form-combination>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button :loading="dialogLoading" type="primary" @click="Saveindustry">保存</el-button>
			</span>
		</el-dialog>

		<!-- 监测绑定弹框 -->
		<dialog-form
			:dialogVisible="GAShowDoalog"
			:attributes="{ title: title + '绑定', confirmBtn: '确认绑定', destroy: true }"
			@close:dialogVisible="val => (GAShowDoalog = val)"
			@confirm="
				cd => {
					confirm('GA4', cd);
				}
			"
		>
			<binding-dialog
				slot="main"
				:title="title"
				:data="gaList"
				:gaColumn="gaColumn"
				:gaListLoading="gaListLoading"
				:optionsList="optionsList"
				@selectChange="val => (associatedAccount = val)"
				@inputChange="val => (gaKeyWords = val)"
				@searchGA="searchGA"
				@getRow="getRow"
			></binding-dialog>
		</dialog-form>
		<!-- 访客识别弹框 -->
		<dialog-form
			:dialogVisible="CDShowDoalog"
			:attributes="{
				width: '35%',
				title: '访客识别',
				confirmBtn: cdBindStatus ? '确认解绑' : '确认绑定',
			}"
			@close:dialogVisible="bindDialogClose"
			@confirm="
				cd => {
					confirm(cdBindStatus ? 'NOBIND' : 'BIND', cd);
				}
			"
		>
			<div slot="main" class="visitors-identify" v-loading="CDShowDoalogLoading">
				<el-form label-width="95px"
					><el-form-item label="项目类型">
						<el-radio-group
							v-model="visitorType"
							:disabled="!!cdBindStatus || leadfeederSelectLoading"
							@change="typeValueChange"
						>
							<el-radio :label="1">leadfeeder</el-radio>
							<el-radio :label="2">visitorQueue</el-radio>
							<el-radio :label="3">leadinfo</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="项目ID" v-if="visitorType !== 3">
						<el-select
							v-model="leadfeederInputId"
							filterable
							remote
							:remote-method="getCheckgroup"
							:loading="leadfeederSelectLoading"
							placeholder="请输入访客识别项目名称或ID进行搜索"
							class="visitors-identify-input"
							style="width: 70%"
							:disabled="!!cdBindStatus"
							ref="leadfeederSelect"
							@focus="selectFocus"
						>
							<el-option
								v-for="item in checkgroup"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="visitorCode" v-if="visitorType === 2 && !cdBindStatus">
						<el-input
							v-model="visitorCode"
							placeholder="请输入visitorCode"
							style="width: 70%"
						></el-input>
					</el-form-item>
					<el-form-item label="leadinfoCode" v-if="visitorType === 3 && !cdBindStatus">
						<el-input
							v-model="leadinfoCode"
							placeholder="请输入leadinfoCode"
							style="width: 70%"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
		</dialog-form>
		<el-dialog
			title="点击跟踪（submit/email/submit_success）一键设置"
			:visible.sync="finishVisible"
			width="20%"
		>
			<span>配置完成，但GA目标需要手动导入ADS</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="close">完成</el-button>
			</span>
		</el-dialog>
		<!-- 提示弹框 -->
		<configBindTipDialog
			:dialogVisible="bindTipDialog"
			:attributes="finishAttributes"
			:showBtn="true"
			:hideClose="BindTipHideClose"
			@dialogClose="dialogClose"
			@bindTipDialogClose="bindTipDialogClose"
			:serviceSiteId="serviceSiteId"
		></configBindTipDialog>
	</div>
</template>

<script>
import dialogForm from '@/components/dialogForm/dialogForm';
import website from '@/backend/services/website/website.js';
import { getGaList, gtmaccount, googleaccount } from '@/backend/services/account/account';
import bindingModule from '@/components/website/binding-module.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import bindingDialog from '@/components/website/bindingDailog.vue';
import configBindTipDialog from '@/backend/pages/website/configBindTipDialog.vue';
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import industry from '@/components/customer/industry';
import customer from '@/backend/services/account/customer.js';
import gscAuthorization from './gscAuthorization.vue';

const list = listPageCreate({
	searchConfig: {
		api: api.website.languageList,
		method: 'POST',
	},
	getQuery(obj, that) {
		let serviceId = that.$route.query.serviceSiteId;
		return Object.assign(obj, {
			serviceId,
		});
	},
});
export default {
	mixins: [list],
	data() {
		return {
			groups: {},
			dialogVisible: false,
			dialogLoading: false,
			finishVisible: false,
			GaDataList: [],
			columns: [],
			detailData: {},
			title: 'GA4',
			optionsList: [],
			gaList: [],
			gaColumn: [
				{
					label: '名称',
					bind: 'value',
				},
				{
					label: 'GA-ID',
					bind: 'id',
				},
			],
			finishAttributes: {},
			textList: {
				sourceText: '点击继续将自动完成询盘溯源一键配置置',
				trackText: '点击继续将自动完成点击跟踪(submit/email)配置',
				conversionsAddText: '点击继续将自动完成增强型潜在客户转化一键配置',
				conversionsRemoveText: '点击继续将关闭增强型潜在客户转化',
				tagGatewayAddText: '点击继续将自动完成Google代码网关一键配置',
				tagGatewayRemoveText: '点击继续将关闭Google代码网关',
				marketingText: '',
			},
			text: '',
			GAShowDoalog: false,
			CDShowDoalog: false,
			visitorType: 1,
			visitorCode: '',
			leadinfoCode: '',
			leadfeederInputId: '',
			leadfeederSelectLoading: false,
			leadfeederInputName: '',
			gaListLoading: false,
			associatedAccount: '',
			gaKeyWords: '',
			currentRow: {},
			marketId: '',
			bindTipDialog: false,
			gtmDetailsData: {},
			BindTipHideClose: false,
			industryList: [],
			serviceSiteId: '',
			checkgroup: [], // 访客自定义分组
			status: ['未配置', '已配置', '配置失败', '配置中'],
			CDShowDoalogLoading: false,
			// cdBindStatus: false,
		};
	},
	computed: {
		enquirySource() {
			let { inquiryTraceability } = this.gtmDetailsData;
			return this.status[inquiryTraceability];
		},
		trackStatus: {
			get: function () {
				let { containerConfigurationStatus } = this.gtmDetailsData;
				return this.status[containerConfigurationStatus];
			},
			set: function () {},
		},
		marketingStatus: {
			get: function () {
				let { markContainerConfigurationStatus } = this.gtmDetailsData;
				return this.status[markContainerConfigurationStatus];
			},
			set: function () {},
		},
		industryStatus: {
			get: function () {
				let { industryMarketContainerConfigurationStatus } = this.gtmDetailsData;
				return this.status[industryMarketContainerConfigurationStatus];
			},
			set: function () {},
		},
		conversionStatus: {
			get: function () {
				let { enhancedConversionStatus } = this.gtmDetailsData;
				return this.status[enhancedConversionStatus];
			},
			set: function () {},
		},
		tagGatewayStatus: {
			get: function () {
				let { googleTagGatewayStatus } = this.gtmDetailsData;
				return this.status[googleTagGatewayStatus];
			},
			set: function () {},
		},
		GABtnDisabled() {
			let { industryName, foreignSecondIndustryName } = this.gtmDetailsData;
			let { gaId, gaMeasurementId } = this.detailData;
			if (industryName && foreignSecondIndustryName && gaId && gaMeasurementId) {
				return false;
			} else {
				return true;
			}
		},
		enquiryBtnDisabled() {
			let { gtmId, gtmEnquiriesAreTracedStatus } = this.detailData;
			return !gtmId || gtmEnquiriesAreTracedStatus == 4;
		},
		cdBindStatus() {
			let { detailData, $route } = this;
			let { query } = $route;
			let { upLineStatus } = query;
			let { leadfeederId } = detailData;
			// if (upLineStatus - 0 === 1) return false;
			if (leadfeederId) return true;
			return false;
		},
	},
	mounted() {
		this.serviceSiteId = this.$route.query.serviceSiteId;
		this.setConfig();
		this.query();
		this.getDetail();
		this.googleaccount();
		this.gtmDetails();
	},
	methods: {
		// 打开外贸行业编辑弹框
		opendialog() {
			this.dialogVisible = true;
			this.setGroups(this.gtmDetailsData);
		},
		// 外贸行业编辑弹窗配置
		setGroups(obj) {
			this.groups = {
				foreign: {
					label: '外贸行业',
					type: 'custom',
					formType: industry,
					requestApi: customer.foreigntrade,
					options: [],
					value: [obj.foreignFirstIndustry, obj.foreignSecondIndustry],
					rules: [
						{
							required: true,
							validator: (rule, value, callback) => {
								if (value[0]) {
									callback();
								} else {
									callback(new Error('此项必填'));
								}
							},
							trigger: 'change',
						},
					],
				},
			};
		},
		// 类型选择变化
		typeValueChange() {
			this.leadfeederInputId = '';
			// this.getCheckgroup('');
		},
		// 获取焦点时触发
		selectFocus() {
			// this.$refs['leadfeederSelect'].focus();
			this.getCheckgroup(this.leadfeederInputName);
		},
		// 获取访客自定义分组
		async getCheckgroup(val) {
			this.leadfeederInputName = val;
			this.leadfeederSelectLoading = true;
			try {
				let res = await website.getCheckgroup({ name: val || '', type: this.visitorType || 1 });
				this.checkgroup = res.data;
				this.leadfeederSelectLoading = false;
				this.setConfig();
			} catch (error) {
				this.$message.info('查看访客自定义分组失败');
			}
		},
		// 外贸行业编辑保存
		async setindustry() {
			this.dialogLoading = true;
			let id = this.$route.query.serviceSiteId;
			try {
				await website.setindustry(
					{ id },
					{
						foreignFirstIndustry: this.groups.foreign.value[0],
						foreignSecondIndustry: this.groups.foreign.value[1],
					}
				);
				this.dialogVisible = false;
				this.dialogLoading = false;
				this.$message.success('保存成功');
				this.gtmDetails();
			} catch (error) {
				this.dialogLoading = false;
				this.$message.error('保存失败');
			}
		},
		Saveindustry() {
			if (this.groups.foreign.value[0]) {
				this.setindustry();
			} else {
				return false;
			}
		},
		async gtmDetails() {
			try {
				let id = this.$route.query.serviceSiteId;
				let res = await website.gtmDetails({ id });
				this.gtmDetailsData = res.data;
				this.industryList[0] = res.data.foreignFirstIndustry;
				this.industryList[1] = res.data.foreignSecondIndustry;
				this.marketId = res.data.markingCode;
				this.setConfig();
			} catch (error) {
				this.$message.info('获取数据失败');
			}
		},
		close() {
			this.finishVisible = false;
		},
		// 获取数据详情
		async getDetail() {
			try {
				let id = this.$route.query.serviceSiteId;
				let res = await website.getDetail({ id });
				this.detailData = res.data;
				this.leadfeederInputId = res.data.leadfeederId;
				this.leadfeederInputName = res.data.leadfeederName;
				this.visitorType = res.data.visitorType || 1;
				// this.getCheckgroup(res.data.leadfeederName);
				this.setConfig();
			} catch (error) {
				this.$message.info('获取GA数据失败');
				console.log(error);
			}
		},
		dialogClose() {
			this.bindTipDialog = false;
		},
		async bindTipDialogClose(attributes, form) {
			let id = this.$route.query.serviceSiteId;

			this.marketId = form.marketId;
			if (attributes.confirmBtn == '我知道了') {
				this.bindTipDialog = false;
				this.BindTipHideClose = false;
			}
			if (attributes.flag == 'source') {
				this.setfinishAttributes(attributes);

				await website.setCode({ id });
				this.gtmDetails();
			}
			let {
				associate,
				goal,
				tags,
				tagsMarket,
				gtmTraceConfig,
				addEnhancedConversions,
				removeEnhancedConversions,
				addGoogleTagGateway,
				removeGoogleTagGateway,
			} = website;
			if (attributes.flag == 'track') {
				this.setfinishAttributes(attributes);
				// await associate({ id });
				await gtmTraceConfig({ id });
				this.GaDataList[3].datalist[0].textLoading = false;
				this.gtmDetails();
				// await goal({ id });
				// this.gtmDetails();
				// await tags({ id });
				// this.gtmDetails();
			}
			if (attributes.flag == 'marketing') {
				this.setfinishAttributes(attributes);
				await tagsMarket({
					serviceId: id,
					code: this.marketId,
					foreignFirstIndustry: form.foreignFirstIndustry[0],
					foreignSecondIndustry: form.foreignFirstIndustry[1],
				});
				this.gtmDetails();
			}

			if (attributes.flag == 'conversionsAdd') {
				this.setfinishAttributes(attributes);
				await addEnhancedConversions({ id });
				this.gtmDetails();
			}

			if (attributes.flag == 'conversionsRemove') {
				this.setfinishAttributes(attributes);
				await removeEnhancedConversions({ id });
				this.gtmDetails();
			}

			if (attributes.flag == 'tagGatewayAdd') {
				this.setfinishAttributes(attributes);
				await addGoogleTagGateway({ id });
				this.gtmDetails();
			}

			if (attributes.flag == 'tagGatewayRemove') {
				this.setfinishAttributes(attributes);
				await removeGoogleTagGateway({ id });
				this.gtmDetails();
			}
		},
		setfinishAttributes(attributes) {
			this.finishAttributes = {
				title: attributes.title,
				width: '400px',
				text: '配置任务进入后台执行，结果将通过企业微信通知', //展示的文字
				confirmBtn: '我知道了',
				flag: attributes.flag,
			};
			this.BindTipHideClose = true;
		},
		setConfig() {
			let that = this;
			let {
				gaMccAccountNmae,
				gaAccountName,
				gaId,
				gtmMccAccountNmae,
				gtmContainerName,
				gtmId,
				leadfeederId,
				leadfeederName,
				gtmMarketCodeId,
				gaMeasurementId,
				gaPropertiesName,
				gaPropertiesPath,
			} = this.detailData;
			let isBisabled = gtmId ? false : true;
			let {
				inquiryTraceability,
				containerConfigurationStatus,
				markContainerConfigurationStatus,
				websiteVisitors,
				combinedIndustry,
				enhancedConversionStatus,
				googleTagGatewayStatus,
			} = this.gtmDetailsData;
			this.GaDataList = [
				{
					title: 'GA4绑定',
					btnName: '编辑',
					hint: '提示：网站无需单独绑定GA4代码',
					btnClick() {
						that.title = 'GA4';
						that.gaList = [];
						that.GAShowDoalog = true;
						that.gaColumn = [
							{
								label: '名称',
								bind: 'name',
							},
							{
								label: 'GA-ID',
								bind: 'gaId',
							},
							{
								label: 'GA4',
								bind: 'propertiesName',
							},
						];
					},
					datalist: [
						{
							label: 'GA授权大账号：',
							value: gaMccAccountNmae || '未绑定',
							textLoading: false,
						},
						{
							label: 'GA账号名称：',
							value: gaAccountName || '未绑定',
							textLoading: false,
						},
						{
							label: 'GA-ID：',
							value: gaId || '未绑定',
							textLoading: false,
						},
						{
							label: 'GA4：',
							value: gaPropertiesName || '未绑定',
							textLoading: false,
							data: `(媒体资源ID：${gaPropertiesPath || '-'}  衡量ID：${gaMeasurementId || '-'})`,
						},
					],
				},
				{
					title: 'GTM绑定',
					disabled: that.GABtnDisabled,
					btnName: '编辑',
					btnHint: 'GTM代码绑定需先绑定GA4，并配置外贸行业',
					hint: '提示：每个网站都需要绑定GTM代码',
					btnClick() {
						that.title = 'GTM';
						that.gaList = [];
						that.GAShowDoalog = true;
						that.gaColumn = [
							{
								label: 'GTM容器名称',
								bind: 'name',
							},
							{
								label: 'GTM-ID',
								bind: 'id',
							},
						];
					},
					datalist: [
						{
							label: 'GTM关联账号：',
							value: gtmMccAccountNmae || '未绑定',
							textLoading: false,
						},
						{
							label: 'GTM容器名称：',
							value: gtmContainerName || '未绑定',
							textLoading: false,
						},
						{
							label: 'GTM-ID：',
							value: gtmId || '未绑定',
							textLoading: false,
						},
					],
				},
				{
					title: '询盘溯源-GA4',
					disabled: isBisabled || inquiryTraceability == 3,
					btnName: inquiryTraceability == 3 ? '配置中' : '询盘溯源一键配置',
					btnHint: '询盘溯源一键配置需先绑定GTM',
					btnClick() {
						that.bindTipDialog = true;
						that.finishAttributes = {
							title: '询盘溯源一键设置',
							width: '400px',
							text: that.textList['sourceText'], //展示的文字
							confirmBtn: '继续',
							flag: 'source',
						};
					},
					datalist: [
						{
							label: '询盘溯源状态：',
							value: that.enquirySource || '未创建',
							textLoading: false,
						},
					],
				},
				{
					title: '点击跟踪-GA4（submit/email/submit_success/whatsapp）',
					btnName: containerConfigurationStatus == 3 ? '配置中' : '一键配置',
					disabled: isBisabled || containerConfigurationStatus == 3,
					btnHint: '点击跟踪-GA4需先绑定GTM',
					height: '85.3px',
					btnClick() {
						that.BindTipHideClose = false;
						that.bindTipDialog = true;
						that.finishAttributes = {
							title: '点击跟踪（submit/email/submit_success）一键设置',
							width: '400px',
							text: that.textList['trackText'], //展示的文字
							confirmBtn: '继续',
							flag: 'track',
						};
					},
					datalist: [
						{
							label: '配置状态：',
							value: that.trackStatus || '未配置',
							textLoading: true,
						},
					],
				},
				{
					title: 'GTM-开启增强型潜在客户转化',
					btnName: [
						{
							name: '一键配置',
							// null、0、2 可点；1、3、isBisabled=true 置灰
							disabled:
								isBisabled || enhancedConversionStatus === 1 || enhancedConversionStatus === 3,
							btnClick: () => {
								that.bindTipDialog = true;
								that.finishAttributes = {
									title: '增强型潜在客户转化一键配置',
									width: '400px',
									text: that.textList['conversionsAddText'],
									confirmBtn: '继续',
									flag: 'conversionsAdd',
								};
							},
						},
						{
							name: '关闭',
							// 只有严格等于1才可用，null/0/2/3/isBisabled=true 全部置灰
							disabled: isBisabled || enhancedConversionStatus !== 1,
							btnClick: () => {
								that.bindTipDialog = true;
								that.finishAttributes = {
									title: '关闭增强型潜在客户转化',
									width: '400px',
									text: that.textList['conversionsRemoveText'],
									confirmBtn: '继续',
									flag: 'conversionsRemove',
								};
							},
						},
					],
					btnHint: '一键配置需先绑定GTM',
					datalist: [
						{
							label: '配置状态：',
							value: that.conversionStatus || '未配置',
							textLoading: true,
						},
					],
				},
				{
					title: 'Google代码网关',
					btnName: [
						{
							name: '一键配置',
							// null、0、2 可点；1、3、isBisabled=true 置灰
							disabled: isBisabled || googleTagGatewayStatus === 1 || googleTagGatewayStatus === 3,
							btnClick: () => {
								that.bindTipDialog = true;
								that.finishAttributes = {
									title: 'Google代码网关一键配置',
									width: '400px',
									text: that.textList['tagGatewayAddText'],
									confirmBtn: '继续',
									flag: 'tagGatewayAdd',
								};
							},
						},
						{
							name: '关闭',
							// 只有严格等于1才可用，null/0/2/3/isBisabled=true 全部置灰
							disabled: isBisabled || googleTagGatewayStatus !== 1,
							btnClick: () => {
								that.bindTipDialog = true;
								that.finishAttributes = {
									title: '关闭Google代码网关',
									width: '400px',
									text: that.textList['tagGatewayRemoveText'],
									confirmBtn: '继续',
									flag: 'tagGatewayRemove',
								};
							},
						},
					],
					btnHint: '一键配置需先绑定GTM',
					datalist: [
						{
							label: '配置状态：',
							value: that.tagGatewayStatus || '未配置',
							textLoading: true,
						},
					],
				},
				{
					title: '访客识别',
					btnName: that.cdBindStatus ? '解绑' : '绑定',
					btnClick: async () => {
						if (that.cdBindStatus) await that.getCheckgroup(that.leadfeederInputName);
						that.CDShowDoalog = true;
					},
					// btnName: [
					// 	{
					// 		name: '绑定',
					// 		btnClick: () => {
					// 			that.cdBindStatus = false;
					// 			that.CDShowDoalog = true;
					// 		},
					// 	},
					// 	{
					// 		name: '解绑',
					// 		btnClick: () => {
					// 			that.cdBindStatus = true;
					// 			that.CDShowDoalog = true;
					// 		},
					// 	},
					// ],
					datalist: [
						{
							label: '项目ID：',
							value: leadfeederName || '未绑定',
							textLoading: false,
						},
					],
				},
				{
					title: '再营销',
					btnName: markContainerConfigurationStatus == 3 ? '配置中' : '一键配置',
					layOutStyle: 'line',
					disabled: true,
					btnClick() {},
					datalist: [
						{
							leftlabel: '配置状态：',
							leftvalue: that.marketingStatus || '未配置',
							rightlabel: '再营销代码ID:',
							rightvalue: gtmMarketCodeId || '-',
						},
						{
							leftlabel: '网站访客再营销：',
							leftvalue: websiteVisitors || '未配置',
						},
						{
							leftlabel: '组合行业再营销：',
							leftvalue: combinedIndustry || '未配置',
						},
					],
				},
			];
			this.columns = [
				{
					label: '语种',
					bind: 'name',
				},
				{
					label: '上线状态',
					bind: 'statusName',
				},
				{
					label: '域名',
					bind: 'domainName',
				},
				{
					label: 'GTM代码绑定状态',
					bind: 'gtmStatusName',
				},
				{
					label: '操作',
					type: 'btnClick',
					style: 'text',
					bind() {
						return [
							{
								text: '一键安装',
								showButton() {
									return that.detailData.sitePlatform === 2;
								},
								async trigger({ id }) {
									try {
										await website.websiteCode({ id });
										that.$message.success('一键安装成功');
										that.query();
									} catch (err) {
										that.$message.warning('一键安装失败');
									}
								},
							},
						];
					},
				},
			];
		},
		// 获取主账号
		async googleaccount() {
			try {
				let res = await googleaccount();
				this.optionsList = res.data;
			} catch (error) {
				this.$message.info('主账号数据错误');
			}
		},
		async searchGA() {
			try {
				this.gaListLoading = true;
				let { associatedAccount, gaKeyWords, title } = this;
				if (!associatedAccount) {
					this.$message.info('请选择关联主账号');
					this.gaListLoading = false;
					return false;
				}
				let options = {};
				let api = getGaList;
				if (gaKeyWords) {
					options.name = gaKeyWords;
				}
				if (associatedAccount) {
					options.mccAccountId = associatedAccount;
				}
				if (title === 'GTM') {
					api = gtmaccount;
				}
				let result = await api({
					...options,
				});
				this.gaList = result.data;
				this.gaListLoading = false;
			} catch (error) {
				this.gaListLoading = false;
			}
		},
		// 选中列表
		getRow(row) {
			this.currentRow = row;
		},
		async confirm(type, cd) {
			if (type === 'GA4') {
				await this.monitorbind(cd);
			}
			if (type === 'BIND') {
				await this.bind(cd);
			}
			if (type === 'NOBIND') {
				await this.noBind(cd);
			}
		},
		bindDialogClose(val) {
			let { detailData } = this;
			let { leadfeederId, leadfeederName, visitorType } = detailData;
			this.leadfeederInputId = leadfeederId;
			this.leadfeederInputName = leadfeederName;
			this.visitorType = visitorType || 1;
			this.CDShowDoalog = val;
		},
		// GA账号绑定
		async monitorbind(cd) {
			try {
				let { currentRow, associatedAccount, title } = this;
				let serviceSiteId = this.$route.query.serviceSiteId;
				let api = website.bindGaAccount;
				let params = {};

				if (title === 'GA4') {
					if (!(currentRow && currentRow.gaId)) {
						cd(false);
						return this.$message.warning('请先选择账号');
					}
					if (!(currentRow && currentRow.propertiesName)) {
						cd(false);
						return this.$message.warning('请选择拥有GA4的账户');
					}
					api = website.bindGaAccount;
					params = {
						id: serviceSiteId,
						gaId: currentRow.gaId,
						mccAccountId: associatedAccount,
						propertiesPath: currentRow.propertiesPath,
					};
				}

				if (title === 'GTM') {
					if (!(currentRow && currentRow.id)) {
						cd(false);
						return this.$message.warning('请先选择账号');
					}
					api = website.bindGTMAccount;
					params = {
						id: serviceSiteId,
						gtmId: currentRow.id,
						mccAccountId: associatedAccount,
						containerPath: currentRow.path,
					};
				}
				await api({ ...params });
				this.$message({
					message: '绑定成功',
					type: 'success',
				});
				this.GAShowDoalog = false;
				this.getDetail();
				cd();
			} catch (error) {
				cd(false);
				this.$message.warning('操作失败');
			}
		},
		// 访客识别绑定
		async bind(cd) {
			let { leadfeederInputId, visitorCode, leadinfoCode, visitorType } = this;
			let serviceSiteId = this.$route.query.serviceSiteId;
			if (!leadfeederInputId && visitorType !== 3) {
				cd(false);
				return this.$message.info('请输入内容');
			}
			try {
				await website.bindleadfeeder({
					leadfeederId: leadfeederInputId,
					serviceSiteId: serviceSiteId,
					visitorCode,
					leadinfoCode,
					type: visitorType,
				});
				this.$message.success('操作成功');
				this.CDShowDoalog = false;
				this.getDetail();
				cd();
			} catch (error) {
				cd(false);
				this.$message.warning('操作失败');
			}
		},
		// 访客识别解绑
		async noBind(cd) {
			let serviceSiteId = this.$route.query.serviceSiteId;
			try {
				await website.unbindleadfeeder({
					serviceSiteId: serviceSiteId,
				});
				this.$message.success('操作成功');
				this.CDShowDoalog = false;
				this.getDetail();
				cd();
			} catch (error) {
				cd(false);
				this.$message.warning('操作失败');
			}
		},
	},
	components: {
		dialogForm,
		bindingModule,
		bindingDialog,
		configBindTipDialog,
		formCombination,
		gscAuthorization,
	},
};
</script>
<style lang="scss" scoped>
.Monitoring-binding {
	color: #333;
	.industryNameEdit {
		margin-left: 5px;
	}
	.customer-info {
		width: 100%;
		height: 66px;
		font-size: 14px;
		padding: 0 22px;
		margin-bottom: 15px;
		box-sizing: border-box;
		border-radius: 4px;
		background-color: #fff;
		box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
		display: flex;
		align-items: center;
		justify-content: space-between;

		.info-item {
			min-width: 15%;
		}
	}

	.data-binding {
		width: 100%;
	}

	.enquiry-source-main {
		text-align: center;
		padding: 15px;

		.enquiry-source-item {
			display: flex;
			justify-content: space-between;
			padding: 10px 20%;
			text-align: left;
			color: #999;

			.item-icon {
				width: 20px;
				height: 20px;
				line-height: 20px;
				font-size: 20px;
			}

			.item-title {
				flex: 1;
				height: 20px;
				line-height: 20px;
				margin-left: 24px;
			}

			.active {
				color: #3da1ff;
			}
		}
	}

	.content {
		width: 60%;
		padding: 0 30px;

		.main {
			margin: 30px 0 40px;
			font-size: 14px;
			color: #333;

			.main-item {
				margin-bottom: 20px;

				.label {
					display: inline-block;
					width: 92px;
					text-align: right;
				}

				.value.inactive {
					color: #999;
				}
			}
		}
	}

	// .visitors-identify {
	// 	display: flex;
	// 	align-items: center;

	// 	.visitors-identify-label {
	// 		min-width: 50px;
	// 	}

	// 	.visitors-identify-input {
	// 		flex: 1;
	// 		margin-left: 30px;
	// 	}
	// }

	.traceability {
		display: flex;

		p {
			margin-bottom: 10px;
		}
	}
}
</style>
